import * as React from "react";

import { useSelector } from "react-redux";

import { NavLink as Link, useLocation } from "react-router-dom";

import { Button, Container, Stack, Typography, Skeleton } from "@mui/material";

import theme from "Shared/styles/theme";

import Logo from "Images/Logo-variant.svg";

import { useAuth } from "../../contexts/auth-context";

import HeaderMenu from "./HeaderMenu";

function Header() {
  const { logout } = useAuth();
  const [logoutText, setLogoutText] = React.useState("Log out");

  const location = useLocation();

  const homepageUrl = localStorage.getItem("redirectUrl");

  const { menus, menuLoading } = useSelector((state) => state.app);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setLogoutText("Logging out...");
    logout();
  };

  const sxProps = {
    "/recall": {},
    "/refurb": {},
    "/parts": { px: ["6.6rem"] }
  };

  const applySxProps =
    Object.keys(sxProps).find((key) => location.pathname.includes(key)) &&
    !location.pathname.includes("vehicle-summary");

  return (
    <Stack
      direction="row"
      bgcolor="#fff"
      height="100px"
      alignItems="center"
      boxShadow="0 4px 12px rgb(33 33 33 / 15%)"
      sx={{ position: "fixed", zIndex: "999", width: "100%" }}
    >
      <Container maxWidth="xl" sx={applySxProps ? sxProps[applySxProps] : { px: ["9.6rem"] }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Link to={homepageUrl || "/home"}>
              <img src={Logo} alt="Logo" />
            </Link>
            <Typography component="h1" variant="h6" fontWeight={500} color={theme.palette.secondary.main}>
              Dealership Management System
            </Typography>
          </Stack>
          <Stack component="ul" direction="row" mb={0} spacing={5} alignItems="center">
            {menuLoading ? (
              <Stack direction="row" alignItems="center" spacing={2}>
                <Skeleton width={100} />
                <Skeleton width={100} />
                <Skeleton width={100} />
              </Stack>
            ) : (
              menus?.items?.length > 0 && menus.items.map((item) => <HeaderMenu item={item} key={item.title} />)
            )}

            <Stack component="li">
              <Button
                id="customized-button"
                aria-haspopup="true"
                disableElevation
                onClick={handleLogout}
                sx={{
                  bgcolor: "transparent",
                  color: "#002238",
                  padding: "6px 0",
                  "&.MuiButton-root": {
                    fontSize: "1.6rem",
                    borderRadius: "0",
                    fontWeight: "600"
                  },
                  "&:hover": {
                    bgcolor: "transparent"
                  }
                }}
              >
                <Typography fontWeight="600" p="6px 0" sx={{ borderBottom: "1px solid rgb(0, 34, 56, .5)" }}>
                  {logoutText}
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
